import * as React from "react"
import {
  RadarIcon,
  Settings2,
  Fence,
  Shield,
  Plane,
  LifeBuoy,
  FileText,
  ShieldCheck,
  RadioTower,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { PlanIndicator } from "@/components/plan-indicator"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  useSidebar,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@uavity-core/ui/components/sidebar"
import { useUser } from "@clerk/clerk-react"
import { Link } from "@tanstack/react-router"
import { Topbar } from "./nav-top"
import { NavGeofences } from "./nav-geofences"


const sidebarItems = [
    {
        title: "Flight Zones",
        url: "/flight-restriction-zones",
        icon: Shield,
    },
    {
        title: "Flight Plans",
        url: "/flight-plans",
        icon: Plane,
        items: [
            {
                title: "All Flight Plans",
                url: "/flight-plans",
            },
            {
                title: "New Flight Plan",
                url: "/flight-plan/create",
            },
        ],
    },
    {
        title: "Live Map",
        url: "/",
        icon: RadarIcon,
    },
    {
        title: "Live Detections",
        url: "/live-detections",
        icon: RadioTower,
    },
    {
        title: "Geofences",
        url: "/geofences",
        icon: Fence,
    },
    {
        title: "Settings",
        url: "/account",
        icon: Settings2,
        items: [
            {
                title: "Account",
                url: "/account",
            },
            {
                title: "Preferences",
                url: "/preferences",
            },
        ],
    },
];

export function AppSidebar({ className, ...props }: React.ComponentProps<typeof Sidebar>) {
    const user = useUser()
    const { state } = useSidebar()

    return (
        <Sidebar
            collapsible="icon"
            {...props}
            className={className}
        >
            <SidebarHeader>
                <Topbar />
            </SidebarHeader>
            <SidebarContent>
                <NavMain items={sidebarItems} />
                <NavGeofences />
            </SidebarContent>
            <SidebarFooter>
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton asChild size="sm">
                            <Link to="/support">
                                <LifeBuoy />
                                <span>Support</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                    <SidebarMenuItem>
                        <SidebarMenuButton asChild size="sm">
                            <Link to="/legal/privacy-policy">
                                <ShieldCheck />
                                <span>Privacy Policy</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                    <SidebarMenuItem>
                        <SidebarMenuButton asChild size="sm">
                            <Link to="/legal/terms-of-use">
                                <FileText />
                                <span>Terms of Use</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
                {state === "expanded" && <PlanIndicator />}
                <NavUser user={
                    {
                        name: user.user?.fullName ?? '',
                        avatar: user.user?.imageUrl ?? '',
                        email: user.user?.emailAddresses[0].emailAddress ?? ''
                    }
                } />
            </SidebarFooter>
            <SidebarRail />
        </Sidebar>
    )
}
